import TextCustomComponent from './text-custom-component/TextCustomComponent';
import PictureCustomComponent from './picture-custom-component/PictureCustomComponent';
import ListVesselCustomComponent from './list-vessel-custom-component/ListVesselCustomComponent';
import DynamicClassifyCustomComponent from './dynamic-classify-custom-component/DynamicClassifyCustomComponent';
import DynamicVesselCustomComponent from './dynamic-vessel-custom-component/DynamicVesselCustomComponent';
import FormVesselCustomComponent from './form-vessel-custom-component/FormVesselCustomComponent';
import InputEleCustomComponent from './input-ele-custom-component/InputEleCustomComponent';
import TextareaEleCustomComponent from './textarea-ele-custom-component/TextareaEleCustomComponent';
import GradeEleCustomComponent from './grade-ele-custom-component/GradeEleCustomComponent';
import SelectEleCustomComponent from './select-ele-custom-component/SelectEleCustomComponent';
import UploadImgCustomComponent from './upload-img-custom-component/UploadImgCustomComponent';
import TimeEleCustomComponent from './time-ele-custom-component/TimeEleCustomComponent';
import DropDownCustomComponent from './drop-down-custom-component/DropDownCustomComponent';
import PicOptionsCustomComponent from './pic-options-custom-component/PicOptionsCustomComponent';
import AddressEleCustomComponent from './address-ele-custom-component/AddressEleCustomComponent';
import FormButtonCustomComponent from './form-button-custom-component/FormButtonCustomComponent';
import FreeVesselCustomComponent from './free-vessel-custom-component/FreeVesselCustomComponent';
import TabNavCustomComponent from './tab-nav-custom-component/TabNavCustomComponent';
import GoodsListCustomComponent from './goods-list-custom-component/GoodsListCustomComponent';
import ButtonCustomComponent from './button-custom-component/ButtonCustomComponent';
import LayoutVesselCustomComponent from './layout-vessel-custom-component/LayoutVesselCustomComponent';
import TitleEleCustomComponent from './title-ele-custom-component/TitleEleCustomComponent';
import NewsCustomComponent from './news-custom-component/NewsCustomComponent';
import CarouselCustomComponent from './carousel-custom-component/CarouselCustomComponent';
import BreaklineCustomComponent from './breakline-custom-component/BreaklineCustomComponent';
import StaticVesselCustomComponent from './static-vessel-custom-component/StaticVesselCustomComponent';
import AudioCustomComponent from './audio-custom-component/AudioCustomComponent';
import AlbumCustomComponent from './album-custom-component/AlbumCustomComponent';
import AnnounceCustomComponent from './announce-custom-component/AnnounceCustomComponent';
import ListCustomComponent from './list-custom-component/ListCustomComponent';
import SuspensionCustomComponent from './suspension-custom-component/SuspensionCustomComponent';
import VideoCustomComponent from './video-custom-component/VideoCustomComponent';
import NewSuspensionCustomComponent from './new-suspension-custom-component/NewSuspensionCustomComponent';
import PopupWindowCustomComponent from './popup-window-custom-component/PopupWindowCustomComponent';
import SlidingPanelCustomComponent from './sliding-panel-custom-component/SlidingPanelCustomComponent';
import FranchiseeListCustomComponent from './franchisee-list-custom-component/FranchiseeListCustomComponent';
import FranchiseeChainCustomComponent from './franchisee-chain-custom-component/FranchiseeChainCustomComponent';
import SidebarCustomComponent from './sidebar-custom-component/SidebarCustomComponent';
import AdvertisingCustomComponent from './advertising-custom-component/AdvertisingCustomComponent';
import PluginCustomComponent from './plugin-custom-component/PluginCustomComponent';
import OfficialAccountCustomComponent from './official-account-component/OfficialAccountCustomComponent';
import ClassifyCustomComponent from './classify-custom-component/ClassifyCustomComponent';
import CountCustomComponent from './count-custom-component/CountCustomComponent';
import NewCountCustomComponent from './new-count-custom-component/NewCountCustomComponent';
import MapCustomComponent from './map-custom-component/MapCustomComponent';
import SearchCustomComponent from './search-custom-component/SearchCustomComponent';
import SortCustomComponent from './sort-custom-component/SortCustomComponent';
import CitylocationCustomComponent from './citylocation-custom-component/CitylocationCustomComponent';
import NewClassifyCustomComponent from './new-classify-custom-component/NewClassifyCustomComponent';
import FilterCustomComponent from './filter-custom-component/FilterCustomComponent';
import CommunityGroupCustomComponent from './community-group-custom-component/CommunityGroupCustomComponent';
import ExchangeCouponCustomComponent from './exchange-coupon-custom-component/ExchangeCouponCustomComponent';
import RowNumCustomComponent from './row-num-custom-component/RowNumCustomComponent';
import TakeoutCustomComponent from './takeout-custom-component/TakeoutCustomComponent';
import TostoreCustomComponent from './tostore-custom-component/TostoreCustomComponent';
import CommunityCustomComponent from './community-custom-component/CommunityCustomComponent';
import TopicCustomComponent from './topic-custom-component/TopicCustomComponent';
import SignInCustomComponent from './sign-in-custom-component/SignInCustomComponent';
import GroupBuyListCustomComponent from './group-buy-list-custom-component/GroupBuyListCustomComponent';
import GroupBuyStatusCustomComponent from'./group-buy-status-custom-component/GroupBuyStatusCustomComponent';
import SeckillCustomComponent from './seckill-custom-component/SeckillCustomComponent';
import TimelineCustomComponent from './timeline-custom-component/TimelineCustomComponent';
import BbsCustomComponent from './bbs-custom-component/BbsCustomComponent';
import VideoListCustomComponent from './video-list-custom-component/VideoListCustomComponent';
import TopicClassifyCustomComponent from './topic-classify-custom-component/TopicClassifyCustomComponent';
import TopicSortCustomComponent from './topic-sort-custom-component/TopicSortCustomComponent';
import UserCenterHeadCustomComponent from './user-center-head-custom-component/UserCenterHeadCustomComponent';
import UserCenterContentCustomComponent from './user-center-content-custom-component/UserCenterContentCustomComponent';
import CustomTopNavCustomComponent from './custom-top-nav-custom-component/CustomTopNavCustomComponent';
import PresellCustomComponent from './presell-custom-component/PresellCustomComponent';
import VerticalListCustomComponent from './vertical-list-custom-component/VerticalListCustomComponent';
import StoredValueCustomComponent from './stored-value-custom-component/StoredValueCustomComponent';
import UploadVideoCustomComponent from './upload-video-custom-component/UploadVideoCustomComponent';
import AnonymousEleCustomComponent from './anonymous-ele-custom-component/AnonymousEleCustomComponent';
import CommunityGoodsListCustomComponent from './community-goods-list-custom-component/CommunityGoodsListCustomComponent';
import DrinkVerticalListCustomComponent from './drink-vertical-list-custom-component/DrinkVerticalListCustomComponent';

/**
 * 组件声明
 */
const customComponentList = {
  // 文本组件
  'text': (props) => <TextCustomComponent {...props} />,
  // 图片组件：单图片
  'picture': (props) => <PictureCustomComponent {...props} />,
  // 动态列表
  'list-vessel': (props, ref) => <ListVesselCustomComponent ref={ref} {...props} />,
  // 动态分类
  'dynamic-classify': (props, ref) => <DynamicClassifyCustomComponent ref={ref} {...props} />,
  // 动态容器
  'dynamic-vessel': (props, ref) => <DynamicVesselCustomComponent ref={ref} {...props} />,
  // 动态表单
  'form-vessel': (props, ref) => <FormVesselCustomComponent ref={ref} {...props} />,
  // 动态表单: 单行文本输入框
  'input-ele': (props) => <InputEleCustomComponent {...props} />,
  // 动态表单: 多行文本输入框
  'textarea-ele': (props) => <TextareaEleCustomComponent {...props} />,
  // 动态表单: 评分
  'grade-ele': (props) => <GradeEleCustomComponent {...props} />,
  // 动态表单: 选项
  'select-ele': (props) => <SelectEleCustomComponent {...props} />,
  // 动态表单: 添加图片
  'upload-img': (props) => <UploadImgCustomComponent {...props} />,
  // 动态表单: 时间
  'time-ele': (props) => <TimeEleCustomComponent {...props} />,
  // 动态表单: 下拉选项
  'drop-down': (props) => <DropDownCustomComponent {...props} />,
  // 动态表单: 图片选项
  'pic-options': (props) => <PicOptionsCustomComponent {...props} />,
  // 动态表单: 地址
  'address-ele': (props) => <AddressEleCustomComponent {...props} />,
  // 动态表单: 提交按钮
  'form-button': (props) => <FormButtonCustomComponent {...props} />,
  // 动态表单: 添加视频
  'upload-video': (props, ref) => <UploadVideoCustomComponent ref={ref} {...props} />,
  // 动态表单：匿名组件
  'anonymous-ele': (props) => <AnonymousEleCustomComponent {...props} />,
  // 自由面板
  'free-vessel': (props) => <FreeVesselCustomComponent {...props} />,
  // 底部导航(函数)
  'tab-nav': (props) => <TabNavCustomComponent {...props} />,
  // 商品列表(电商、到店、预约)
  'goods-list': (props, ref) => <GoodsListCustomComponent ref={ref} {...props} />,
  // 按钮组件
  'button': (props) => <ButtonCustomComponent {...props} />,
  // 双栏布局组件
  'layout-vessel': (props) => <LayoutVesselCustomComponent {...props} />,
  // 标题组件
  'title-ele': (props) => <TitleEleCustomComponent {...props} />,
  // 资讯组件
  'news': (props, ref) => <NewsCustomComponent ref={ref} {...props} />,
  // 轮播组件
  'carousel': (props) => <CarouselCustomComponent {...props} />,
  // 分割线组件
  'breakline': (props) => <BreaklineCustomComponent {...props} />,
  // 面板组件
  'static-vessel': (props) => <StaticVesselCustomComponent {...props} />,
  // 轮播组件
  'audio': (props, ref) => <AudioCustomComponent ref={ref} {...props} />,
  // 图片列表组件
  'album': (props) => <AlbumCustomComponent {...props} />,
  // 公告组件
  'announce': (props) => <AnnounceCustomComponent {...props} />,
  // 图文集组件
  'list': (props) => <ListCustomComponent {...props} />,
  // 固定悬浮窗组件
  'suspension': (props) => <SuspensionCustomComponent {...props} />,
  // 视频组件
  'video': (props, ref) => <VideoCustomComponent ref={ref} {...props} />,
  // 收缩悬浮窗组件
  'new-suspension': (props, ref) => <NewSuspensionCustomComponent ref={ref} {...props} />,
  // 弹窗组件
  'popup-window': (props, ref) => <PopupWindowCustomComponent ref={ref} {...props} />,
  // 滑动面板组件
  'sliding-panel': (props, ref) => <SlidingPanelCustomComponent ref={ref} {...props} />,
  // 多商家组件
  'franchisee-list': (props, ref) => <FranchiseeListCustomComponent ref={ref} {...props} />,
  // 连锁多商家组件
  'franchisee-chain': (props, ref) => <FranchiseeChainCustomComponent ref={ref} {...props} />,
  // 侧边栏组件
  'sidebar': (props, ref) => <SidebarCustomComponent ref={ref} {...props} />,
  // 广告组件（仅微信可用）
  'advertising': (props) => <AdvertisingCustomComponent {...props} />,
  // 插件组件（仅微信可用）
  'plugin': (props) => <PluginCustomComponent {...props} />,
  // 公众号关注组件（仅微信可用）
  'official-account': (props) => <OfficialAccountCustomComponent {...props} />,
  // 旧版分类组件（暂不预览）
  'classify': (props) => <ClassifyCustomComponent {...props} />,
  // 旧版计数器组件（暂不预览）
  'count': (props) => <CountCustomComponent ref={ref} {...props} />,
  // 新版计数器组件
  'new-count': (props) => <NewCountCustomComponent {...props} />,
  // 地图组件
  'map': (props, ref) => <MapCustomComponent ref={ref} {...props} />,
  // 列表相关：搜索
  'search': (props) => <SearchCustomComponent {...props} />,
  // 列表相关：排序
  'sort': (props) => <SortCustomComponent {...props} />,
  // 列表相关：城市定位
  'citylocation': (props) => <CitylocationCustomComponent {...props} />,
  // 列表相关：列表分类
  'new-classify': (props, ref) => <NewClassifyCustomComponent ref={ref} {...props} />,
  // 列表相关：筛选
  'filter': (props, ref) => <FilterCustomComponent ref={ref} {...props} />,
  // 社区团购活动列表组件
  'community-group': (props, ref) => <CommunityGroupCustomComponent ref={ref} {...props} />,
  // 社区团购单商品列表组件
  'community-goods-list': (props, ref) => <CommunityGoodsListCustomComponent ref={ref} {...props} />,
  // 可兑换优惠券组件
  'exchange-coupon': (props, ref) => <ExchangeCouponCustomComponent ref={ref} {...props} />,
  // 排号组件
  'row-num': (props, ref) => <RowNumCustomComponent ref={ref} {...props} />,
  // 外卖组件
  'waimai': (props, ref) => <TakeoutCustomComponent ref={ref} {...props} />,
  // 到店组件
  'tostore': (props, ref) => <TostoreCustomComponent ref={ref} {...props} />,
  // 社区：圈组列表 组件
  'community': (props, ref) => <CommunityCustomComponent ref={ref} {...props} />,
  // 社区：话题列表 组件
  'topic': (props, ref) => <TopicCustomComponent ref={ref} {...props} />,
  // 每日签到组件
  'sign-in': (props, ref) => <SignInCustomComponent ref={ref} {...props} />,
  // 拼团列表列表组件
  'group-buy-list': (props, ref) => <GroupBuyListCustomComponent ref={ref} {...props} />,
  // 拼团状态组件
  'group-buy-status': (props, ref) => <GroupBuyStatusCustomComponent ref={ref} {...props} />,
  // 秒杀组件
  'seckill': (props, ref) => <SeckillCustomComponent ref={ref} {...props} />,
  // 秒杀时间轴组件
  'timeline': (props, ref) => <TimelineCustomComponent ref={ref} {...props} />,
  // 评论组件
  'bbs': (props, ref) => <BbsCustomComponent ref={ref} {...props} />,
  // 视频列表组件
  'video-list': (props, ref) => <VideoListCustomComponent ref={ref} {...props} />,
  // 话题分类组件
  'topic-classify': (props, ref) => <TopicClassifyCustomComponent ref={ref} {...props} />,
  // 话题排序组件
  'topic-sort': (props, ref) => <TopicSortCustomComponent ref={ref} {...props} />,
  // 个人中心 头部
  'user-center-head': (props, ref) => <UserCenterHeadCustomComponent ref={ref} {...props} />,
  // 个人中心 内容
  'user-center-content': (props, ref) => <UserCenterContentCustomComponent ref={ref} {...props} />,
  // 自定义顶部导航
  'custom-top-nav': (props) => <CustomTopNavCustomComponent {...props} />,
  // 预售组件
  'presell': (props, ref) => <PresellCustomComponent ref={ref} {...props} />,
  // 竖版列表组件
  'vertical-list': (props, ref) => <VerticalListCustomComponent ref={ref} {...props} />,
  // 储值列表组件
  'stored-value': (props, ref) => <StoredValueCustomComponent ref={ref} {...props} />,
  // 饮品列表
  'drink-vertical-list': (props, ref) => <DrinkVerticalListCustomComponent ref={ref} {...props} />,
}
export default customComponentList;


// WEBPACK FOOTER //
// ./src/custom-component/customComponentList.jsx